export const getStaffUpdatesCustomerId = (): number | null => {
  try {
    const id = Number(window.localStorage.getItem('customerId'));
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
};

// Confirmation history is local to this customer, store and browser/device.
const storageKey = (customerId: number, storeId: number) => (
  `customer-staff-seen:v1:${customerId}:${storeId}`
);

const readSeenIds = (key: string): number[] | null => {
  const stored = window.localStorage.getItem(key);
  if (stored === null) return null;
  const parsed: unknown = JSON.parse(stored);
  if (!Array.isArray(parsed) || !parsed.every((id) => Number.isInteger(id) && id > 0)) {
    return null;
  }
  return parsed;
};

export const getNewStaffIds = (customerId: number, storeId: number, staffIds: number[]): number[] => {
  try {
    const key = storageKey(customerId, storeId);
    const seenIds = readSeenIds(key);
    // First visit establishes a baseline; existing staff should not all appear new.
    if (seenIds === null) {
      window.localStorage.setItem(key, JSON.stringify(staffIds));
      return [];
    }
    return staffIds.filter((id) => !seenIds.includes(id));
  } catch {
    // If local storage is unavailable, do not show an unconfirmable NEW tag.
    return [];
  }
};

export const markStaffListSeen = (customerId: number, storeId: number, staffIds: number[]): void => {
  try {
    const key = storageKey(customerId, storeId);
    const seenIds = readSeenIds(key) ?? [];
    // Keep previous IDs so hiding and re-showing a known staff member is not NEW.
    const merged = Array.from(new Set([...seenIds, ...staffIds]));
    window.localStorage.setItem(key, JSON.stringify(merged));
  } catch {
    // Ignore storage failures and keep the staff directory usable.
  }
};
